import PropTypes from 'prop-types';
import { useCallback } from 'react';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import FormWrapper from '@/components/form/Wrapper';
import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { useOfferActive } from '../context';
import { OfferProvider, useOfferStore } from '../store';

const OfferForm = ({ isAttribute }) => {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit, reset } } = useOfferStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { active } = useOfferActive()

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleClose = useCallback(() => {
    history.push("/offer/offers")
    reset()
  }, [reset])

  const handleSubmitAndUpdate = useCallback(async (payload, isAttribute = false, attrDeleted = false) => {
    try {
      await handleSubmit({ ...payload, active })

      let message
      if (attrDeleted) {
        message = "deleted"
      } else if (payload.action === "add") {
        message = "created"
      } else {
        message = "edited"
      }

      if (!payload.id) {
        handleClose()
      }

      handleSuccess('Success', `${isAttribute ? 'Attribute' : 'Offer'} ${message}.`)
    } catch {
      handleError('Error', `${isAttribute ? 'Attribute' : 'Offer'} was not saved.`)
    }
  }, [handleSubmit, handleClose, handleSuccess, handleError, active])

  if (!item) {
    return null
  }

  if (item.id) {
    return <>
      <FormWrapper title="Offer">
        <Form data={item} isAttribute={isAttribute} handleSubmit={handleSubmitAndUpdate} onCancel={handleClose} />
      </FormWrapper>
    </>
  }

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}
    title='Add Offer'>
    <Helmet title="Offer" />
    <Form handleSubmit={handleSubmitAndUpdate} onCancel={handleClose} />
  </DefaultSheet>
};

OfferForm.defaultProps = {
  isAttribute: false,
}

OfferForm.propTypes = {
  match: PropTypes.object,
  isAttribute: PropTypes.bool,
};

export default function OfferFormLayout(props) {
  return <OfferProvider>
    <OfferForm {...props} />
  </OfferProvider>
}
